'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface Metric {
  label: string;
  value: string;
  icon: string;
  color: string;
}

const LiveMetrics = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const metrics: Metric[] = [
    {
      label: t('dashboard.todaysEarnings'),
      value: '$47,250',
      icon: 'BanknotesIcon',
      color: 'text-green-600',
    },
    {
      label: t('dashboard.activeDeals'),
      value: '23',
      icon: 'RocketLaunchIcon',
      color: 'text-blue-600',
    },
    {
      label: t('dashboard.pendingReturns'),
      value: '$1.2M',
      icon: 'ClockIcon',
      color: 'text-orange-600',
    },
    {
      label: t('dashboard.successRate'),
      value: '98.7%',
      icon: 'CheckBadgeIcon',
      color: 'text-purple-600',
    },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-gradient-to-r from-accent/10 to-primary/10 rounded-lg p-6 border border-accent/20">
        <div className="animate-pulse flex items-center justify-between">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex-1">
              <div className="h-4 bg-muted rounded w-20 mb-2"></div>
              <div className="h-6 bg-muted rounded w-24"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-accent/10 to-primary/10 rounded-lg p-6 border shadow-card border-lime-600">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {metrics.map((metric, index) => (
          <div key={index} className="flex items-center space-x-3">
            <div className={`p-2 bg-white rounded-lg shadow-sm ${metric.color}`}>
              <Icon name={metric.icon as any} size={24} variant="solid" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground">{metric.label}</p>
              <p className="text-xl font-heading font-bold text-foreground">{metric.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveMetrics;